/* ============================================================
 * ENISSATI · Quiz Capillaire
 * Spec: §5 logique de calcul, §6 templates résultats, §9.4 tracking
 * Stack: vanilla JS, localStorage (clé enissati_quiz_state), zero deps.
 * ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-quiz-section]');
  if (!root) return;

  const STORAGE_KEY = 'enissati_quiz_state_v3';
  const STORAGE_TTL_MS = 24 * 60 * 60 * 1000; // 24h
  const QUIZ_NAME = 'diagnostic_capillaire';

  const cfg = {
    questionsUrl: root.dataset.questionsUrl,
    klaviyoListId: root.dataset.klaviyoListId || '',
    ficheUrl: root.dataset.ficheUrl || '#',
    pdp: {
      hydra: root.dataset.pdpHydra,
      nigella: root.dataset.pdpNigella,
      btxHydra: root.dataset.pdpBtxHydra,
      btxNigella: root.dataset.pdpBtxNigella,
      lisseur: root.dataset.pdpLisseur,
    },
    formationUrl: root.dataset.formationUrl,
    pack: {
      preLissage: root.dataset.packPreLissage,
      comboHydra: root.dataset.packComboHydra,
      comboNigella: root.dataset.packComboNigella,
      toutInclus: root.dataset.packToutInclus,
    },
    img: {
      hydra: root.dataset.imgHydra || '',
      nigella: root.dataset.imgNigella || '',
      btxHydra: root.dataset.imgBtxHydra || '',
      btxNigella: root.dataset.imgBtxNigella || '',
      lisseur: root.dataset.imgLisseur || '',
    },
    collection: {
      hydra: root.dataset.collectionHydra || '',
      nigella: root.dataset.collectionNigella || '',
    },
    variant: {
      hydra: root.dataset.variantHydra || '',
      nigella: root.dataset.variantNigella || '',
      btxHydra: root.dataset.variantBtxHydra || '',
      btxNigella: root.dataset.variantBtxNigella || '',
      lisseur: root.dataset.variantLisseur || '',
    },
  };

  var CART_SVG = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M3 5h2l2.5 11h11l2-8H7'/><circle cx='9' cy='20' r='1.5'/><circle cx='17' cy='20' r='1.5'/></svg>";
  var CHECK_SVG = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M5 12l5 5L19 7'/></svg>";

  /* Product card componente: imagem 1:1 lateral + nome/preço/CTAs (Voir + Add to cart).
     opts: { img, alt, name, url, price, oldPrice, ctaText, ctaData, variantId } */
  function productCard(opts) {
    if (!opts || (!opts.img && !opts.name)) return '';
    var name = escapeHtml(opts.name || '');
    var url = opts.url || '#';
    var ctaText = escapeHtml(opts.ctaText || 'Voir le produit →');
    var ctaData = escapeHtml(opts.ctaData || 'view_product');
    var priceHtml = '';
    if (opts.price) {
      priceHtml = '<p class="ss-quiz__pc-price">' + escapeHtml(opts.price) +
        (opts.oldPrice ? '<span class="ss-quiz__pc-price-old">' + escapeHtml(opts.oldPrice) + '</span>' : '') +
        '</p>';
    }
    var imgHtml = opts.img
      ? '<div class="ss-quiz__pc-img"><img src="' + escapeHtml(opts.img) + '" alt="' + escapeHtml(opts.alt || opts.name || '') + '" loading="lazy" crossorigin="anonymous" referrerpolicy="no-referrer" /></div>'
      : '<div class="ss-quiz__pc-img ss-quiz__pc-img--empty" aria-hidden="true"></div>';
    var addBtnHtml = '';
    if (opts.variantId) {
      addBtnHtml =
        '<button type="button" class="ss-quiz__btn ss-quiz__btn--primary ss-quiz__btn--icon" ' +
          'data-add-to-cart data-variant-id="' + escapeHtml(opts.variantId) + '" ' +
          'data-cta="' + ctaData + '_add_cart" aria-label="Ajouter au panier">' +
          '<span class="ss-quiz__btn-icon" aria-hidden="true">' + CART_SVG + '</span>' +
        '</button>';
    }
    return '<div class="ss-quiz__pc">' +
      imgHtml +
      '<div class="ss-quiz__pc-info">' +
        '<h3 class="ss-quiz__pc-name">' + name + '</h3>' +
        priceHtml +
        '<div class="ss-quiz__pc-ctas">' +
          '<a href="' + escapeHtml(url) + '" class="ss-quiz__btn ss-quiz__btn--outline ss-quiz__btn--sm" data-cta="' + ctaData + '">' + ctaText + '</a>' +
          addBtnHtml +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* CTA de categoria: link pra collection (Hydra ou Nigella) */
  function categoryCta(url, label, dataCta) {
    if (!url) return '';
    return '<div class="ss-quiz__result-ctas">' +
      '<a href="' + escapeHtml(url) + '" class="ss-quiz__btn ss-quiz__btn--outline" data-cta="' + escapeHtml(dataCta || 'view_collection') + '">' + escapeHtml(label) + '</a>' +
    '</div>';
  }

  /* Extrai cor de fundo da imagem do produto (sample dos 4 cantos, escolhe o mais opaco).
     Aplica como bg do .ss-quiz__result-img. Fallback silencioso em caso de CORS error. */
  function extractBgFromImg(img) {
    try {
      var w = Math.min(img.naturalWidth || 0, 200);
      var h = Math.min(img.naturalHeight || 0, 200);
      if (!w || !h) return null;
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      var corners = [
        ctx.getImageData(0, 0, 1, 1).data,
        ctx.getImageData(w - 1, 0, 1, 1).data,
        ctx.getImageData(0, h - 1, 1, 1).data,
        ctx.getImageData(w - 1, h - 1, 1, 1).data
      ];
      // Pick corner with highest alpha
      var best = corners[0];
      for (var i = 1; i < corners.length; i++) {
        if (corners[i][3] > best[3]) best = corners[i];
      }
      if (best[3] < 50) return null; // mostly transparent → no bg color
      return 'rgb(' + best[0] + ',' + best[1] + ',' + best[2] + ')';
    } catch (e) {
      return null; // CORS or canvas error
    }
  }

  function bindResultImgBg() {
    var imgs = el.stage.querySelectorAll('.ss-quiz__pc-img img');
    Array.prototype.forEach.call(imgs, function (img) {
      var apply = function () {
        var bg = extractBgFromImg(img);
        if (bg) {
          var wrap = img.closest('.ss-quiz__pc');
          if (wrap) wrap.style.background = bg;
        }
      };
      if (img.complete && img.naturalWidth > 0) apply();
      else img.addEventListener('load', apply, { once: true });
    });
  }

  const el = {
    stage: root.querySelector('[data-quiz-stage]'),
    progBar: root.querySelector('[data-quiz-progress-bar]'),
    progWrap: root.querySelector('[data-quiz-progress-wrap]'),
    progCurrent: root.querySelector('[data-quiz-current]'),
    progTotal: root.querySelector('[data-quiz-total]'),
    prev: root.querySelector('[data-quiz-prev]'),
    next: root.querySelector('[data-quiz-next]'),
    nav: root.querySelector('[data-quiz-nav]'),
    restart: root.querySelector('[data-quiz-restart]'),
  };

  // ---- State ------------------------------------------------
  const state = {
    questions: [],          // serialized from json
    answers: {},            // {q1: 'q1_a', ..., q8: ['q8_a','q8_b']}
    cursor: 0,              // index in active questions
    phase: 'loading',       // loading | quiz | gate | result
    email: '',
    result: null,           // {result, overlays, scores, flags}
    abandonedTracked: false,
  };

  // ---- Storage ----------------------------------------------
  function saveState() {
    try {
      const data = {
        ts: Date.now(),
        answers: state.answers,
        cursor: state.cursor,
        phase: state.phase,
        email: state.email,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* quota or disabled */ }
  }

  function loadState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data.ts || Date.now() - data.ts > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) { return null; }
  }

  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    state.answers = {};
    state.cursor = 0;
    state.phase = 'quiz';
    state.email = '';
    state.result = null;
    state.abandonedTracked = false;
  }

  // ---- Tracking ---------------------------------------------
  function gaTrack(event, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', event, Object.assign({ quiz_name: QUIZ_NAME }, params || {}));
      }
    } catch (e) {}
  }

  function klaviyoTrack(event, payload) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', event, payload || {}]);
    } catch (e) {}
  }

  function klaviyoIdentify(email, traits) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', Object.assign({ $email: email }, traits || {})]);
    } catch (e) {}
  }

  // ---- Active questions (handles q6b conditional) -----------
  function activeQuestions() {
    return state.questions.filter(q => {
      if (!q.conditional) return true;
      const c = q.conditional;
      return state.answers[c.question] === c.value;
    });
  }

  function currentQuestion() {
    const arr = activeQuestions();
    return arr[state.cursor] || null;
  }

  // ---- Scoring & decision (spec §5) -------------------------
  function computeResult() {
    const scores = { HYDRA: 0, NIGELLA: 0, BTX_SOLO: 0, BTX_COMBO: 0, LISSEUR: 0, FORMATION: 0 };
    const flags = new Set();

    state.questions.forEach(q => {
      const ans = state.answers[q.id];
      if (ans == null) return;
      const ids = Array.isArray(ans) ? ans : [ans];
      ids.forEach(optId => {
        const opt = q.options.find(o => o.id === optId);
        if (!opt) return;
        if (opt.scores) {
          Object.entries(opt.scores).forEach(([k, v]) => { scores[k] = (scores[k] || 0) + v; });
        }
        if (opt.flags) opt.flags.forEach(f => flags.add(f));
      });
    });

    let result;

    // Step 1 — contre-indication dure
    if (flags.has('FLAG_CONTRAINDICATION')) {
      result = 'result_E_henna_metallique';
    }
    // Step 2 — BTX standalone prioritaire
    else if (scores.BTX_SOLO >= 5 && scores.HYDRA < 4 && scores.NIGELLA < 4) {
      result = flags.has('FLAG_PRE_LISSAGE') ? 'result_C_btx_pre_lissage' : 'result_G_btx_entretien';
    }
    // Step 3 — Combo BTX + Lissage
    else if (scores.BTX_COMBO >= 3) {
      result = scores.NIGELLA > scores.HYDRA ? 'result_H_combo_nigella' : 'result_I_combo_hydra';
    }
    // Step 4 — Lissage simple
    else {
      if (scores.HYDRA > scores.NIGELLA) result = 'result_A_hydra';
      else if (scores.NIGELLA > scores.HYDRA) result = 'result_B_nigella';
      else {
        // tie-break sur le type de cheveux (q1) — q2 densité supprimée du quiz
        const q1 = state.answers.q1;
        result = (q1 === 'q1_c' || q1 === 'q1_d') ? 'result_B_nigella' : 'result_A_hydra';
      }
    }

    // Step 5 — Overlays
    const overlays = [];
    if (scores.FORMATION >= 2 && ['result_A_hydra', 'result_B_nigella', 'result_H_combo_nigella', 'result_I_combo_hydra'].includes(result)) {
      overlays.push('overlay_F_debutante');
    }
    if (scores.LISSEUR >= 1 && !result.includes('E_') && !result.includes('D_')) {
      overlays.push('overlay_lisseur');
    }
    if (scores.BTX_SOLO >= 2 && !result.includes('btx') && !result.includes('combo')) {
      overlays.push('overlay_btx_crosssell');
    }
    if (flags.has('FLAG_FICHE')) {
      overlays.push('overlay_fiche_anamnese');
      // If FLAG_FICHE present we ALSO surface a soft result_D as an upfront recommendation
      if (result.startsWith('result_A') || result.startsWith('result_B') || result.startsWith('result_H') || result.startsWith('result_I')) {
        // Keep main result but push fiche overlay first; do NOT switch to D unless we want a hard gate
      }
    }
    if (flags.has('FLAG_ATTENTION')) overlays.push('overlay_attention_henne');

    return { result, overlays, scores, flagsArr: Array.from(flags) };
  }

  // ---- Render: progress -------------------------------------
  function updateProgress() {
    const total = activeQuestions().length;
    el.progTotal.textContent = total;
    if (state.phase === 'quiz') {
      const c = Math.min(state.cursor + 1, total);
      el.progCurrent.textContent = c;
      el.progBar.style.width = (c / total * 100) + '%';
      el.progWrap.style.display = '';
    } else if (state.phase === 'gate') {
      el.progCurrent.textContent = total;
      el.progBar.style.width = '100%';
      el.progWrap.style.display = '';
    } else {
      el.progWrap.style.display = 'none';
    }
  }

  // ---- Render: question -------------------------------------
  function renderQuestion() {
    const q = currentQuestion();
    if (!q) return;
    const ans = state.answers[q.id];
    const isMulti = q.type === 'multiple';
    const inputType = isMulti ? 'checkbox' : 'radio';

    const optionsHtml = q.options.map(opt => {
      const checked = isMulti
        ? (Array.isArray(ans) && ans.includes(opt.id))
        : (ans === opt.id);
      // opt.icon contém SVG inline (controlado por nós em quiz-questions.json) — NÃO escapar.
      const iconHtml = opt.icon ? '<span class="ss-quiz__option-icon" aria-hidden="true">' + opt.icon + '</span>' : '';
      // Multi-select shows checkbox marker on the right; single-select shows arrow →
      const trailHtml = isMulti
        ? '<span class="ss-quiz__option-check" aria-hidden="true"></span>'
        : '<span class="ss-quiz__option-arrow" aria-hidden="true">→</span>';
      return (
        '<li class="ss-quiz__option">' +
          '<label class="ss-quiz__option-wrap">' +
            '<input type="' + inputType + '" name="' + q.id + '" value="' + opt.id + '" class="ss-quiz__option-input"' + (checked ? ' checked' : '') + (opt.exclusive ? ' data-exclusive="true"' : '') + '/>' +
            '<span class="ss-quiz__option-card">' +
              iconHtml +
              '<span class="ss-quiz__option-label">' + escapeHtml(opt.label) + '</span>' +
              trailHtml +
            '</span>' +
          '</label>' +
        '</li>'
      );
    }).join('');

    el.stage.innerHTML =
      '<p class="ss-quiz__question-label">' + escapeHtml(q.label) + '</p>' +
      (isMulti ? '<p class="ss-quiz__question-helper">Plusieurs réponses possibles.</p>' : '') +
      '<ul class="ss-quiz__options' + (isMulti ? ' ss-quiz__options--multi' : '') + '">' + optionsHtml + '</ul>';

    el.stage.querySelectorAll('.ss-quiz__option-input').forEach(input => {
      input.addEventListener('change', () => onOptionChange(q, input, isMulti));
    });

    updateNavButtons();
    el.nav.hidden = false;
    el.restart.hidden = state.cursor === 0;
  }

  var quizStartedTracked = false;
  function trackQuizStartOnce() {
    if (quizStartedTracked) return;
    quizStartedTracked = true;
    gaTrack('quiz_started', {});
  }

  function onOptionChange(q, input, isMulti) {
    trackQuizStartOnce();
    if (!isMulti) {
      state.answers[q.id] = input.value;
    } else {
      // multi: handle exclusive "Aucune"
      const checked = el.stage.querySelectorAll('.ss-quiz__option-input:checked');
      const values = Array.from(checked).map(i => i.value);
      const exclusiveOpt = q.options.find(o => o.exclusive);
      if (exclusiveOpt) {
        if (input.value === exclusiveOpt.id && input.checked) {
          // uncheck others
          el.stage.querySelectorAll('.ss-quiz__option-input').forEach(i => {
            if (i !== input) i.checked = false;
          });
          state.answers[q.id] = [input.value];
        } else if (input.checked && input.value !== exclusiveOpt.id) {
          // uncheck exclusive
          const exInput = el.stage.querySelector('.ss-quiz__option-input[value="' + exclusiveOpt.id + '"]');
          if (exInput) exInput.checked = false;
          state.answers[q.id] = values.filter(v => v !== exclusiveOpt.id);
          if (!state.answers[q.id].includes(input.value)) state.answers[q.id].push(input.value);
        } else {
          state.answers[q.id] = values;
        }
      } else {
        state.answers[q.id] = values;
      }
    }
    saveState();
    gaTrack('quiz_question_answered', { question_id: q.id, answer: Array.isArray(state.answers[q.id]) ? state.answers[q.id].join(',') : state.answers[q.id] });
    updateNavButtons();
  }

  function isCurrentAnswered() {
    const q = currentQuestion();
    if (!q) return false;
    const a = state.answers[q.id];
    if (q.type === 'multiple') return Array.isArray(a) && a.length > 0;
    return !!a;
  }

  function updateNavButtons() {
    el.next.disabled = !isCurrentAnswered();
    el.prev.disabled = state.cursor === 0;
    const isLast = state.cursor === activeQuestions().length - 1;
    el.next.textContent = isLast ? 'Voir mon résultat →' : 'Suivant →';
  }

  // ---- Navigation -------------------------------------------
  function goNext() {
    // Sur le gate, « Voir mon résultat → » continue vers le résultat SANS e-mail
    if (state.phase === 'gate') { proceedToResult(false); return; }
    if (!isCurrentAnswered()) return;
    const isLast = state.cursor === activeQuestions().length - 1;
    if (isLast) {
      state.phase = 'gate';
      saveState();
      renderEmailGate();
    } else {
      state.cursor++;
      saveState();
      updateProgress();
      renderQuestion();
    }
  }

  function goPrev() {
    if (state.phase === 'gate') {
      state.phase = 'quiz';
      state.cursor = activeQuestions().length - 1;
      saveState();
      updateProgress();
      renderQuestion();
      return;
    }
    if (state.cursor > 0) {
      state.cursor--;
      saveState();
      updateProgress();
      renderQuestion();
    }
  }

  // ---- Render: email gate -----------------------------------
  function renderEmailGate() {
    el.stage.innerHTML =
      '<div class="ss-quiz__gate">' +
        '<div class="ss-quiz__gate-icon" aria-hidden="true">🎯</div>' +
        '<h2 class="ss-quiz__gate-title">Voilà ! Nous avons calculé votre recommandation.</h2>' +
        '<p class="ss-quiz__gate-text">Souhaitez-vous recevoir votre diagnostic complet en PDF,<br/>avec la routine adaptée à vos cheveux ?</p>' +
        '<form class="ss-quiz__gate-form" data-quiz-gate-form novalidate>' +
          '<input type="email" class="ss-quiz__gate-input" placeholder="Votre e-mail" required autocomplete="email" data-quiz-gate-input />' +
          '<button type="submit" class="ss-quiz__btn ss-quiz__btn--primary ss-quiz__btn--full">Recevoir mon diagnostic →</button>' +
          '<p class="ss-quiz__gate-status" data-quiz-gate-status></p>' +
        '</form>' +
      '</div>';

    // Nav reste visible sur le gate : « ← Précédent » (retour) + « Voir mon résultat → » (continuer SANS e-mail)
    el.nav.hidden = false;
    el.prev.disabled = false;
    el.next.disabled = false;
    el.next.textContent = 'Voir mon résultat →';
    el.restart.hidden = false;
    updateProgress();

    el.stage.querySelector('[data-quiz-gate-form]').addEventListener('submit', onGateSubmit);
  }

  function onGateSubmit(e) {
    e.preventDefault();
    const input = el.stage.querySelector('[data-quiz-gate-input]');
    const status = el.stage.querySelector('[data-quiz-gate-status]');
    const email = (input.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      status.textContent = 'Merci de saisir un e-mail valide.';
      status.className = 'ss-quiz__gate-status ss-quiz__gate-status--err';
      input.focus();
      return;
    }
    state.email = email;
    saveState();
    proceedToResult(true);
  }

  function proceedToResult(emailCaptured) {
    state.result = computeResult();
    state.phase = 'result';
    saveState();

    gaTrack('quiz_completed', { result: state.result.result });
    klaviyoTrack('Completed Hair Quiz', {
      result: state.result.result,
      overlays: state.result.overlays,
      scores: state.result.scores,
      flags: state.result.flagsArr,
    });

    if (emailCaptured && state.email) {
      gaTrack('quiz_email_captured', { result: state.result.result });
      klaviyoIdentify(state.email, {
        quiz_result: state.result.result,
        quiz_overlays: state.result.overlays.join(','),
      });
      // Best-effort: nudge the Klaviyo onsite SDK to surface forms / lists if available
    }

    renderResult();
  }

  // ---- Render: result ---------------------------------------
  function renderResult() {
    el.nav.hidden = true;
    el.restart.hidden = false;
    updateProgress();

    const r = state.result.result;
    const overlays = state.result.overlays;
    const scores = state.result.scores;

    let html = '';
    const ovHenne = overlays.includes('overlay_attention_henne') ? renderOverlayAttentionHenne() : '';
    const ovFiche = overlays.includes('overlay_fiche_anamnese') ? renderOverlayFiche() : '';
    const ovFormation = overlays.includes('overlay_F_debutante') ? renderOverlayFormation() : '';
    const ovLisseur = overlays.includes('overlay_lisseur') ? renderOverlayLisseur() : '';
    const ovBtx = overlays.includes('overlay_btx_crosssell') ? renderOverlayBtxCrossSell() : '';

    switch (r) {
      case 'result_A_hydra':            html = renderResultA() + ovFormation + ovLisseur + ovBtx + ovFiche; break;
      case 'result_B_nigella':          html = renderResultB() + ovFormation + ovLisseur + ovBtx + ovFiche; break;
      case 'result_C_btx_pre_lissage':  html = ovHenne + renderResultC() + ovFiche; break;
      case 'result_D_fiche':            html = renderResultD(); break;
      case 'result_E_henna_metallique': html = renderResultE(); break;
      case 'result_G_btx_entretien':    html = renderResultG(scores) + ovLisseur; break;
      case 'result_H_combo_nigella':    html = ovHenne + renderResultH() + ovFormation + ovLisseur + ovFiche; break;
      case 'result_I_combo_hydra':      html = ovHenne + renderResultI() + ovFormation + ovLisseur + ovFiche; break;
      default:                          html = renderResultA();
    }

    el.stage.innerHTML = '<div class="ss-quiz__result">' + html + '</div>';

    // CTA tracking
    el.stage.querySelectorAll('[data-cta]').forEach(btn => {
      btn.addEventListener('click', () => {
        gaTrack('quiz_cta_clicked', { cta: btn.dataset.cta, result: r });
      });
    });

    // Add-to-cart binding
    bindAddToCart(r);

    // Extract bg from product img and apply to card
    bindResultImgBg();
  }

  /* AJAX add to cart via /cart/add.js. Mostra feedback inline (check icon)
     e dispara custom event 'cart:item-added' que muitos temas Shopify escutam
     pra abrir o cart drawer. */
  function bindAddToCart(resultKey) {
    var buttons = el.stage.querySelectorAll('[data-add-to-cart]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (data) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          var iconSpan = btn.querySelector('.ss-quiz__btn-icon');
          if (iconSpan) iconSpan.innerHTML = CHECK_SVG;
          gaTrack('quiz_add_to_cart', { variant_id: variantId, result: resultKey });
          // Atualiza badge + drawer (contrato Krunkers: documentElement + detail.cart)
          fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          }).catch(function () {});
          // Reset depois de 2.5s
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-done');
            if (iconSpan) iconSpan.innerHTML = CART_SVG;
          }, 2500);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          // Fallback: vai pra PDP
          var pdpLink = btn.parentElement.querySelector('a');
          if (pdpLink && pdpLink.href) window.location = pdpLink.href;
        });
      });
    });
  }

  // ---- Result templates (spec §6) ---------------------------
  function cta(href, label, classes, dataCta) {
    return '<a href="' + (href || '#') + '" class="ss-quiz__btn ' + (classes || 'ss-quiz__btn--primary') + '" data-cta="' + escapeHtml(dataCta || label) + '">' + escapeHtml(label) + '</a>';
  }

  function renderResultA() {
    return '' +
      '<p class="ss-quiz__result-eyebrow">✨ VOTRE MATCH PARFAIT</p>' +
      '<h2 class="ss-quiz__result-title">Lissage Hydra Complex 300 g</h2>' +
      productCard({
        img: cfg.img.hydra, alt: 'Lissage Hydra Complex 300g',
        name: 'Lissage Hydra Complex 300 g',
        price: '79,99 €', oldPrice: '99,99 €',
        url: cfg.pdp.hydra, variantId: cfg.variant.hydra, ctaData: 'hydra'
      }) +
      '<div class="ss-quiz__result-block">' +
        '<p class="ss-quiz__result-block-title">Pourquoi pour vous ?</p>' +
        '<ul class="ss-quiz__result-list">' +
          '<li>Cheveux fins à moyens, ondulés</li>' +
          '<li>Formule légère, hydratante · aloe vera + huile d\'argan</li>' +
          '<li>Fini naturel, avec mouvement</li>' +
        '</ul>' +
      '</div>' +
      '<div class="ss-quiz__result-gift">🎁 Inclus : Formation en ligne (valeur 99,99 €)</div>' +
      categoryCta(cfg.collection.hydra, 'Voir toute la collection Hydra →', 'view_collection_hydra');
  }

  function renderResultB() {
    return '' +
      '<p class="ss-quiz__result-eyebrow">✨ VOTRE MATCH PARFAIT</p>' +
      '<h2 class="ss-quiz__result-title">Lissage Nigella 300 g</h2>' +
      productCard({
        img: cfg.img.nigella, alt: 'Lissage Nigella 300g',
        name: 'Lissage Nigella 300 g',
        price: '109,99 €',
        url: cfg.pdp.nigella, variantId: cfg.variant.nigella, ctaData: 'nigella'
      }) +
      '<div class="ss-quiz__result-block">' +
        '<p class="ss-quiz__result-block-title">Pourquoi pour vous ?</p>' +
        '<ul class="ss-quiz__result-list">' +
          '<li>Cheveux bouclés à frisés moyens · discipline extrême</li>' +
          '<li>4 huiles : Nigelle · Argan · Ricin · Amla</li>' +
          '<li>Reconstruction profonde de la fibre</li>' +
        '</ul>' +
      '</div>' +
      categoryCta(cfg.collection.nigella, 'Voir toute la collection Nigella →', 'view_collection_nigella');
  }

  function renderResultC() {
    return '' +
      '<p class="ss-quiz__result-eyebrow" style="color:var(--quiz-accent);">⚠️ VOS CHEVEUX DOIVENT ÊTRE PRÉPARÉS D\'ABORD</p>' +
      '<div class="ss-quiz__result-block ss-quiz__result-block--warn">' +
        '<p>Vous avez indiqué une décoloration ou des cheveux abîmés. Appliquer un lissage directement risque de casser la fibre. Voici le protocole en 2 étapes :</p>' +
      '</div>' +
      '<div class="ss-quiz__pc-step">' +
        '<span class="ss-quiz__pc-step-num">1</span>' +
        '<div class="ss-quiz__pc-step-info"><strong>Maintenant</strong><p>Reconstruction de la fibre capillaire.</p></div>' +
      '</div>' +
      productCard({
        img: cfg.img.btxHydra, alt: 'BTX Hydra Therapy 300g',
        name: 'BTX Hydra Therapy 300 g', price: '59,99 €',
        url: cfg.pdp.btxHydra, variantId: cfg.variant.btxHydra, ctaData: 'btx_hydra_step1'
      }) +
      '<div class="ss-quiz__pc-step">' +
        '<span class="ss-quiz__pc-step-num">2</span>' +
        '<div class="ss-quiz__pc-step-info"><strong>Après reconstruction</strong><p>Quand la fibre sera récupérée, le lissage s\'appliquera en toute sécurité.</p></div>' +
      '</div>' +
      productCard({
        img: cfg.img.hydra, alt: 'Lissage Hydra Complex 300g',
        name: 'Lissage Hydra Complex 300 g', price: '79,99 €', oldPrice: '99,99 €',
        url: cfg.pdp.hydra, variantId: cfg.variant.hydra, ctaData: 'hydra_step2'
      }) +
      categoryCta(cfg.collection.hydra, 'Voir toute la collection Hydra →', 'view_collection_hydra');
  }

  function renderResultD() {
    return '' +
      '<p class="ss-quiz__result-eyebrow" style="color:var(--quiz-accent);">🩺 RECOMMANDÉ AVEC PRÉCAUTION</p>' +
      '<h2 class="ss-quiz__result-title">Un avis personnalisé avant achat.</h2>' +
      '<div class="ss-quiz__result-block ss-quiz__result-block--warn">' +
        '<p>Vous avez indiqué une situation qui demande attention (grossesse, cheveux élastiques ou allergie). Notre formule est <strong>sans formol</strong> et sûre pour les femmes enceintes, mais nous recommandons d\'évaluer au cas par cas.</p>' +
      '</div>' +
      '<div class="ss-quiz__result-ctas">' +
        cta(cfg.ficheUrl, 'Recevoir la fiche d\'anamnèse gratuite →', 'ss-quiz__btn--primary', 'fiche_anamnese') +
      '</div>' +
      '<p style="font-size:12px;color:var(--quiz-faded);text-align:center;margin:0;">Questionnaire de 2 min + checklist personnalisée pour valider votre routine en toute sécurité.</p>';
  }

  function renderResultE() {
    return '' +
      '<p class="ss-quiz__result-eyebrow" style="color:#C0392B;">🚫 NOUS NE RECOMMANDONS PAS DE LISSAGE POUR LE MOMENT</p>' +
      '<div class="ss-quiz__result-block ss-quiz__result-block--block">' +
        '<p>Le henné aux sels métalliques peut réagir chimiquement avec les produits de lissage, causant de sérieux dommages à la fibre capillaire.</p>' +
      '</div>' +
      '<div class="ss-quiz__result-block">' +
        '<p class="ss-quiz__result-block-title">Notre suggestion</p>' +
        '<ol class="ss-quiz__result-list" style="counter-reset:item;">' +
          '<li><strong>Attendez</strong> — au moins 6 mois sans henné.</li>' +
          '<li><strong>Consultez</strong> — un professionnel capillaire.</li>' +
          '<li><strong>Considérez</strong> — produits de soin et nutrition jusqu\'à ce que la fibre se renouvelle.</li>' +
        '</ol>' +
      '</div>' +
      '<div class="ss-quiz__result-ctas">' +
        cta(cfg.ficheUrl, 'Recevoir notre routine de nutrition (PDF gratuit) →', 'ss-quiz__btn--outline', 'nutrition_pdf') +
      '</div>';
  }

  function renderResultG(scores) {
    var isNigella = scores.NIGELLA > scores.HYDRA;
    var btxName = isNigella ? 'BTX Nigella' : 'BTX Hydra Therapy';
    var btxUrl = isNigella ? cfg.pdp.btxNigella : cfg.pdp.btxHydra;
    var btxImg = isNigella ? cfg.img.btxNigella : cfg.img.btxHydra;
    var btxVid = isNigella ? cfg.variant.btxNigella : cfg.variant.btxHydra;
    var collectionUrl = isNigella ? cfg.collection.nigella : cfg.collection.hydra;
    var collectionLabel = isNigella ? 'Voir toute la collection Nigella →' : 'Voir toute la collection Hydra →';
    return '' +
      '<p class="ss-quiz__result-eyebrow">✨ L\'ENTRETIEN EST CE QU\'IL VOUS FAUT</p>' +
      '<h2 class="ss-quiz__result-title">' + btxName + ' 300 g</h2>' +
      productCard({
        img: btxImg, alt: btxName + ' 300g',
        name: btxName + ' 300 g',
        price: '59,99 €',
        url: btxUrl, variantId: btxVid, ctaData: 'btx_entretien'
      }) +
      '<div class="ss-quiz__result-block">' +
        '<p>Vous avez déjà un lissage et vous voulez prolonger sa durée. Le BTX est une reconstruction intermédiaire qui renouvelle votre lissage actuel, sans appliquer un nouveau lissage.</p>' +
      '</div>' +
      '<div class="ss-quiz__result-gift">🎁 Inclus : vidéo d\'application BTX (gratuit)</div>' +
      categoryCta(collectionUrl, collectionLabel, isNigella ? 'view_collection_nigella' : 'view_collection_hydra');
  }

  function renderResultH() {
    return '' +
      '<p class="ss-quiz__result-eyebrow">✨ VOTRE PROTOCOLE PARFAIT</p>' +
      '<h2 class="ss-quiz__result-title">BTX Nigella + Lissage Nigella</h2>' +
      '<div class="ss-quiz__result-block">' +
        '<p>Vos cheveux sont épais, denses et indomptables. Le BTX prépare la fibre, puis le Lissage Nigella s\'applique en séquence.</p>' +
        '<p style="margin-top:10px;"><strong>Résultat :</strong> un lissé plus parfait et plus durable que le lissage seul.</p>' +
      '</div>' +
      productCard({
        img: cfg.img.btxNigella, alt: 'BTX Nigella 300g',
        name: 'BTX Nigella 300 g (étape 1)', price: '59,99 €',
        url: cfg.pdp.btxNigella, variantId: cfg.variant.btxNigella, ctaData: 'btx_nigella_combo'
      }) +
      productCard({
        img: cfg.img.nigella, alt: 'Lissage Nigella 300g',
        name: 'Lissage Nigella 300 g (étape 2)', price: '109,99 €',
        url: cfg.pdp.nigella, variantId: cfg.variant.nigella, ctaData: 'nigella_combo'
      }) +
      '<div class="ss-quiz__result-block">' +
        '<p class="ss-quiz__result-block-title">Protocole</p>' +
        '<ol class="ss-quiz__result-list">' +
          '<li>BTX Nigella (reconstruction)</li>' +
          '<li>Lissage Nigella (même session ou jour suivant)</li>' +
          '<li>Scellement plaque 230 °C</li>' +
        '</ol>' +
      '</div>' +
      '<div class="ss-quiz__result-gift">🎁 Inclus : Formation en ligne (valeur 99,99 €) + vidéo combo</div>' +
      categoryCta(cfg.collection.nigella, 'Voir toute la collection Nigella →', 'view_collection_nigella');
  }

  function renderResultI() {
    return '' +
      '<p class="ss-quiz__result-eyebrow">✨ VOTRE PROTOCOLE PARFAIT</p>' +
      '<h2 class="ss-quiz__result-title">BTX Hydra + Lissage Hydra Complex</h2>' +
      '<div class="ss-quiz__result-block">' +
        '<p>Vos cheveux sont moyens à denses, avec du volume. Le BTX Hydra prépare et hydrate, puis le Lissage Hydra Complex applique.</p>' +
        '<p style="margin-top:10px;"><strong>Résultat :</strong> un lissé naturel, avec mouvement, et plus durable que le lissage seul.</p>' +
      '</div>' +
      productCard({
        img: cfg.img.btxHydra, alt: 'BTX Hydra Therapy 300g',
        name: 'BTX Hydra Therapy 300 g (étape 1)', price: '59,99 €',
        url: cfg.pdp.btxHydra, variantId: cfg.variant.btxHydra, ctaData: 'btx_hydra_combo'
      }) +
      productCard({
        img: cfg.img.hydra, alt: 'Lissage Hydra Complex 300g',
        name: 'Lissage Hydra Complex 300 g (étape 2)', price: '79,99 €', oldPrice: '99,99 €',
        url: cfg.pdp.hydra, variantId: cfg.variant.hydra, ctaData: 'hydra_combo'
      }) +
      '<div class="ss-quiz__result-gift">🎁 Inclus : Formation en ligne + vidéo combo</div>' +
      categoryCta(cfg.collection.hydra, 'Voir toute la collection Hydra →', 'view_collection_hydra');
  }

  // ---- Overlays ---------------------------------------------
  function renderOverlayFormation() {
    return '' +
      '<div class="ss-quiz__overlay">' +
        '<p class="ss-quiz__overlay-title">🎓 Première fois que vous faites un lissage ?</p>' +
        '<p class="ss-quiz__overlay-text">Notre Formation en ligne de 8 modules vous guide pas à pas — diagnostic, dosage, temps de pose, scellement. <strong>Incluse gratuitement</strong> avec votre achat, accès à vie.</p>' +
        '<div class="ss-quiz__result-ctas">' +
          cta(cfg.formationUrl, 'Voir la formation', 'ss-quiz__btn--outline', 'view_formation') +
        '</div>' +
      '</div>';
  }

  function renderOverlayLisseur() {
    return '' +
      '<div class="ss-quiz__overlay">' +
        '<p class="ss-quiz__overlay-title">🔥 Pour sceller le résultat à la maison</p>' +
        '<p class="ss-quiz__overlay-text">Lisseur Lizze Titanium — plaques titane, 230 °C, indispensable pour fixer le lissage.</p>' +
        '<div class="ss-quiz__result-ctas">' +
          cta(cfg.pdp.lisseur, 'Voir le lisseur (109,99 €)', 'ss-quiz__btn--outline', 'view_lisseur') +
        '</div>' +
      '</div>';
  }

  function renderOverlayBtxCrossSell() {
    return '' +
      '<div class="ss-quiz__overlay">' +
        '<p class="ss-quiz__overlay-title">✨ Ajoutez le BTX à votre routine</p>' +
        '<p class="ss-quiz__overlay-text">Une session BTX par trimestre prolonge votre lissage de 2-3 mois et restaure la brillance.</p>' +
      '</div>';
  }

  function renderOverlayFiche() {
    return '' +
      '<div class="ss-quiz__overlay">' +
        '<p class="ss-quiz__overlay-title">🩺 Fiche d\'anamnèse recommandée</p>' +
        '<p class="ss-quiz__overlay-text">Vous avez indiqué une situation qui demande attention. Notre fiche gratuite vous guide pour valider l\'application en toute sécurité.</p>' +
        '<div class="ss-quiz__result-ctas">' +
          cta(cfg.ficheUrl, 'Recevoir la fiche', 'ss-quiz__btn--outline', 'fiche_anamnese_overlay') +
        '</div>' +
      '</div>';
  }

  function renderOverlayAttentionHenne() {
    return '' +
      '<div class="ss-quiz__overlay" style="border:1px solid var(--quiz-accent);">' +
        '<p class="ss-quiz__overlay-title">⚠️ Attention henné</p>' +
        '<p class="ss-quiz__overlay-text">Vous avez utilisé un henné commercial. Nous recommandons un test de mèche avant tout traitement pour confirmer la compatibilité.</p>' +
      '</div>';
  }

  // ---- Utils ------------------------------------------------
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ---- Abandoned tracking on unload ------------------------
  function trackAbandoned() {
    if (state.abandonedTracked) return;
    if (state.phase === 'quiz' && Object.keys(state.answers).length > 0 && state.phase !== 'result') {
      const q = currentQuestion();
      gaTrack('quiz_abandoned', { last_question: q ? q.id : 'unknown' });
      state.abandonedTracked = true;
    }
  }

  // ---- Init -------------------------------------------------
  async function init() {
    // Load questions
    try {
      const res = await fetch(cfg.questionsUrl, { credentials: 'same-origin' });
      const json = await res.json();
      state.questions = json.questions;
    } catch (e) {
      el.stage.innerHTML = '<p style="text-align:center;color:#C0392B;">Erreur de chargement du quiz. Rechargez la page.</p>';
      return;
    }

    // Restore state
    const saved = loadState();
    if (saved) {
      state.answers = saved.answers || {};
      state.cursor = Math.min(saved.cursor || 0, activeQuestions().length - 1);
      state.phase = saved.phase || 'quiz';
      state.email = saved.email || '';
      if (state.phase === 'result') {
        state.result = computeResult();
      }
    } else {
      state.phase = 'quiz';
      // quiz_started migrou pro 1º clique de resposta (onOptionChange) —
      // no load da home inflava a métrica sem interação real.
    }

    // Wire nav
    el.next.addEventListener('click', goNext);
    el.prev.addEventListener('click', goPrev);
    el.restart.addEventListener('click', () => {
      clearState();
      gaTrack('quiz_started', { restart: true });
      updateProgress();
      renderQuestion();
    });

    // Keyboard: arrow keys + Enter when no input focused
    document.addEventListener('keydown', (e) => {
      if (!root.contains(document.activeElement) && document.activeElement !== document.body) return;
      const tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (e.key === 'Enter' && !el.next.disabled) { goNext(); }
      else if (e.key === 'ArrowLeft' && !el.prev.disabled) { goPrev(); }
    });

    window.addEventListener('beforeunload', trackAbandoned);

    updateProgress();
    if (state.phase === 'result' && state.result) {
      renderResult();
    } else if (state.phase === 'gate') {
      renderEmailGate();
    } else {
      renderQuestion();
    }
  }

  init();
})();
